// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"874418e6","209":"630389c0","239":"a9bb65ba","438":"91fb3933","448":"7bbeed20","706":"553ab2e2","727":"791947de"}[chunkId] + ".chunk.js";
};